import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useParams, useNavigate } from 'react-router-dom'
import '../../css/generals/paper.css'
import styles from '../../css/modals/Modal.module.css'
import Swal from 'sweetalert2'
import { postData } from '../../actions/servicesHttp'
import { popupSimple } from '../generals/popups'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function ModalInstallApplications ({ show, onHide, title, btnError, btnSuccess }) {
  const { id } = useParams()
  const [files, setFiles] = useState(null)
  const { t } = useTranslation('dashboardGroup')
  const navigate = useNavigate()

  function inputFileHandling () {
    const input = document.querySelector('#fileToInstallApplicationsGroup')

    input.addEventListener('change', e => {
      const span = document.querySelector('#file_name_install_applications_group')

      if (input?.files?.length === 0) {
        span.innerHTML = t('modalApplications.label1')
      } else if (input?.files?.length > 0) {
        span.innerHTML = input.files[0].name
        setFiles(input.files)
      }
    })
  }

  const uploadContent = async () => {
    const f = new FormData()

    if (files !== null) {
      for (let i = 0; i < files.length; i++) {
        f.append('files', files[i])
      }

      let timerInterval

      Swal.fire({
        title: t('modalApplications.label2'),
        html: '',
        timer: 30000,
        timerProgressBar: false,
        didOpen: () => {
          Swal.showLoading()
          timerInterval = setInterval(500)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }
      })

      const response = await postData('upload/install', f, navigate)

      if (response.data.length !== false) {
        let url = response.data.url
        url = url.trim()
        const splitUrl = url.split('/')
        installApps(url, splitUrl)
        setFiles(null)
        onHide()
        setFiles(null)
      } else {
        popupSimple('error', t('modalApplications.label3'))
      }
    } else {
      popupSimple('info', t('modalApplications.label4'))
    }
  }

  const installApps = async (url, fileName) => {
    const json = {
      action: 'install',
      data: {
        fileName: fileName[fileName.length - 2] + '.' + fileName[fileName.length - 1],
        url,
        type: 'app'
      },
      date: new Date(Date.now()),
      devicesId: [],
      groupsId: [parseInt(id)]
    }

    const { data } = await postData('actions', [json], navigate)

    if ((data[0].result === true)) {
      popupSimple('success', t('modalApplications.label5'))
    } else {
      popupSimple('error', t('modalApplications.label6'))
    }
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'installApplications'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.modalBackgroundChangeBody}>
                        <label>{t('modalApplications.label7')}</label>
                        <input type="file" accept=".exe, .apk" id="fileToInstallApplicationsGroup" name="files" className={styles.fancy_file}/>
                        <label htmlFor="fileToInstallApplicationsGroup" className={styles.fancy_file_label}>
                            <span className={styles.fancy_file_button} onClick={() => inputFileHandling()}>
                                <i className="pi pi-download"></i></span>
                            <span className={styles.fancy_file_name}>
                                <span id="file_name_install_applications_group">{t('modalApplications.label1')}</span>
                            </span>
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {
                      onHide()
                      setFiles(null)
                    }} variant="danger">
                        {btnError}
                    </Button>
                    <Button onClick={() => uploadContent()} variant="primary" id="btnModalSucess" >
                        {btnSuccess}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalInstallApplications.propTypes = {
  onHide: PropTypes.func,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string
}
